import React from 'react';
import banner from './img/courses-bannner.png'
import './Basic-cyber-page.css';
import CareerForm from './careerform';
import Footer from '../Components/footer'

const ciscoPage = () => {
  return (
    <div className='cisco-container'>
       <div className='cisco-banner-box'>
                  <div className='cisco-banner'>
        <img src={banner} alt=''/>
                  </div>
                </div>

<div className='detail-box'>
    <div className='cisco-heading'>
        <h1>Certificate in Cyber Security  Course </h1>
        <p>Cybersecurity is the practice of protecting systems, networks and data from digital attacks while promoting responsible and sustainable use of technology. In today’s connected world, cybersecurity not only secures information but also supports eco-friendly digital growth by reducing wasteful practices and system misuse.
</p>
        </div> 
        <div className='carrer-section'>
        <div className='skills-section'>
<h2>🛡️ Top Certificate in Cyber Security Skills You’ll Master</h2>
<div className='skills-name'>
<span>Real-Time Threat Detection</span>
<span>Network Security Fundamentals</span>
</div>
<div className='skills-name'>
  <span>Identity & Access Control</span>
  <span>Incident Response Handling</span>
</div>
<div className='skills-name'>
<span>Vulnerability Assessment Techniques</span>
</div>

        </div>

         <div className='job-roles'>
           <h1>💼 JOB ROLES AFTER COURSE</h1>
           <div className='job-name'>
            <span>Cyber Security Analyst</span>
            <span>Information Security Executive</span>
            </div>
             <div className='job-name'>
            <span>Ethical Hacker (Beginner Level)</span>
            <span>Network Security Engineer</span>
            </div>
             <div className='job-name'>
                 <span>SOC Analyst (Security Operations Center)</span>
           </div>
        </div>
        
        </div>
        <div className='course-discription'>
            <h1>About this Course</h1>
<p>Protect networks, devices, people, and data from unauthorized access and cyberattacks using Security Information and Event Management (SIEM) tools. Identify common risks, threats, and vulnerabilities, as well as techniques to mitigate them. By joining this program, you not only gain essential skills but also unlock a gateway to outstanding career opportunities in this dynamic field. Our Cybersecurity Industrial Training in Delhi NCR/Gurgaon equips you with the critical skills required to tackle today’s cybersecurity challenges, combining theoretical and hands-on learning experiences. By joining this program, you not only gain essential skills but also unlock a gateway to outstanding career opportunities in this dynamic field.
</p>
        </div>
        </div>
        <div className='join-container'>
        <div className='join-box'>
<div className='join-div'>
<h1>Who Should Join This Certificate in Cyber Security Course</h1>
<p><span> ✔ </span>Students who want to start a smart career in cybersecurity from zero. </p>
<p><span> ✔ </span>Freshers looking for an easy entry into IT with beginner-friendly skills.</p>
<p><span> ✔ </span>Beginners who want to learn ethical hacking step by step.</p>
<p><span> ✔ </span>Non-technical learners ready to understand security in a simple way.</p>
<p><span> ✔ </span>IT beginners who want to build a strong base in cyber protection.</p>
<p><span> ✔ </span>Job seekers aiming for a safe, stable, and growing career field. </p>
<p><span> ✔ </span>Freelancers who want to start earning with basic security skills.</p>
<p><span> ✔ </span>Self-learners searching for a clear and guided learning path.</p>
<p><span> ✔ </span>Working people who want to upgrade skills without confusion.</p>
<p><span> ✔ </span>Anyone curious to protect personal data, devices, and online life.</p>

</div>
        </div>

                <CareerForm/>
        </div>

    <div className="modules-container">

      {/* Heading */}
      <h1 className="module">Course RoadMap</h1>
      <p className="subtitle">
        Step-by-step modules to master Certificate in Cyber Security
      </p>

      {/* Grid */}
      <div className="modules-grid">

        {/* Card 1 */}
        <div className="module-card">
          <div className="circle">01</div>
          <h3>Cyber Security Basics</h3>
          <p>
            Understand cybersecurity basics, threats, and importance of protecting digital information.
          </p>
        </div>

        {/* Card 2 */}
        <div className="module-card">
          <div className="circle">02</div>
          <h3>Types of Cyber Threats</h3>
          <p>
            Learn malware, phishing, ransomware, and common cyber attack techniques.
          </p>
        </div>

        {/* Card 3 */}
        <div className="module-card">
          <div className="circle">03</div>
          <h3>Network Security Basics</h3>
          <p>
         Understand firewalls, secure networks, and protecting data during transmission.
          </p>
        </div>

        {/* Card 4 */}
        <div className="module-card">
          <div className="circle">04</div>
          <h3>Password & Authentication Security</h3>
          <p>
          Create strong passwords and implement secure authentication methods effectively.
          </p>
        </div>

        {/* Card 5 */}
        <div className="module-card">
          <div className="circle">05</div>
          <h3>Internet & Email Security</h3>
          <p>
            Identify safe browsing practices and prevent phishing and email-based attacks.
          </p>
        </div>

        {/* Card 6 */}
        <div className="module-card">
          <div className="circle">06</div>
          <h3>Data Protection & Privacy</h3>
          <p>
           Learn data encryption, privacy principles, and protecting sensitive information online.
          </p>
        </div>

      </div>

        {/* Grid */}
      <div className="modules-grid">

        {/* Card 7 */}
        <div className="module-card">
          <div className="circle">07</div>
          <h3>Device & Endpoint Security</h3>
          <p>
           Secure computers, mobiles, and devices from viruses and unauthorized access.
          </p>
        </div>

        {/* Card 8 */}
        <div className="module-card">
          <div className="circle">08</div>
          <h3>Social Engineering Awareness</h3>
          <p>
            Recognize manipulation techniques and prevent human-based cyber security attacks.
          </p>
        </div>

        {/* Card 9 */}
        <div className="module-card">
          <div className="circle">09</div>
          <h3>Cloud Security Basics</h3>
          <p>
            Understand cloud risks and basic practices for securing online storage.
          </p>
        </div>

        {/* Card 10 */}
        <div className="module-card">
          <div className="circle">10</div>
          <h3>Cyber Laws & Ethics</h3>
          <p>
          Learn cyber laws, digital ethics, and responsible online behavior guidelines.
          </p>
        </div>

        {/* Card 11 */}
        <div className="module-card">
          <div className="circle">11</div>
          <h3>Security Best Practices</h3>
          <p>
           Apply daily cybersecurity habits to stay protected from evolving cyber threats.
          </p>
        </div>

        {/* Card 12 */}
        <div className="module-card">
          <div className="circle">12</div>
          <h3>Practical Cyber Security Basics</h3>
          <p>
           Hands-on practice with basic security tools and real-world protection techniques.
          </p>
        </div>

      </div>
    </div>

<div>
        <Footer/>
</div>
    </div>
  )
}

export default ciscoPage
